import { memo } from 'react'

import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { getStateContent } from 'modules/app-registry/templates/FullPageAppTemplate'
import { Navigate, useLocation } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { ProtectedAppProps } from './ProtectedApp.types'

const ProtectedApp = memo((props: ProtectedAppProps) => {
  const { apps: availableApps, isLoading: isLoadingApps } = useAvailableApps()
  const { user } = useUserContext()

  const location = useLocation()

  const isLoading = isLoadingApps || !user

  if (user && user?.user_roles?.includes('anonymous')) {
    return <Navigate to='/login' replace />
  }

  if (isLoading) {
    return getStateContent({ isLoaded: !isLoading, isError: false }, null)
  }

  const hasUserAccessToRoute = Object.values(availableApps).some(
    ({ path }) =>
      path !== '/' && new RegExp(`${path}/?.*`).test(location.pathname)
  )

  if (!hasUserAccessToRoute) {
    return <Navigate to='/' replace />
  }

  return <>{props.children}</>
})

ProtectedApp.displayName = 'ProtectedApp'

export { ProtectedApp }
